// ============================================================================
// Button.jsx — Corelia UI v1.4
// Bouton standardisé avec FormLayout intégré
// Support variantes pleines + pastel
// ============================================================================

import React from "react";
import theme from "../../../../styles/theme";
import FormLayout from "../../../../components/reusable/Forms/FormLayout";

const Button = ({
  label,
  labelPosition = "left",
  labelWidth = null,
  align = "center",
  width,

  variant = "blue",
  children,
  onClick,
  disabled = false,

  style = {},
}) => {
  const palette = theme.buttons[variant] || theme.buttons.blue;
  const disabledPalette = theme.buttons.disabled;

  const isPastel = String(variant).toLowerCase().includes("pastel");

  const baseStyle = {
    backgroundColor: disabled ? disabledPalette.background : palette.background,
    color: disabled ? disabledPalette.color : palette.color,

    borderRadius: theme.borders.radius.md,

    minHeight: theme.form.field.minHeight,
    padding: `0 ${theme.spacing.md}px`,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    fontFamily: theme.typography.button.fontFamily,
    fontSize: theme.typography.button.fontSize,
    fontWeight: theme.typography.button.fontWeight,
    lineHeight: theme.typography.button.lineHeight,
    letterSpacing: theme.typography.button.letterSpacing,
    textTransform: theme.typography.button.textTransform,

    border: disabled
      ? "none"
      : isPastel
      ? `1px solid ${palette.border || "transparent"}`
      : "none",

    cursor: disabled ? "not-allowed" : "pointer",
    boxShadow: theme.shadows.sm,
    transition: "background-color 0.2s ease, border-color 0.2s ease",

    boxSizing: "border-box",
    whiteSpace: "nowrap",

    ...style,
  };

  return (
    <FormLayout
      label={label}
      labelPosition={labelPosition}
      labelWidth={labelWidth}
      align={align}
      width={width}
    >
      <button
        disabled={disabled}
        onClick={disabled ? undefined : onClick}
        style={baseStyle}
        onMouseEnter={(e) => {
          if (!disabled) {
            e.currentTarget.style.backgroundColor = palette.hover;
          }
        }}
        onMouseLeave={(e) => {
          if (!disabled) {
            e.currentTarget.style.backgroundColor = palette.background;
          }
        }}
        onFocus={(e) => {
          if (!disabled) {
            e.currentTarget.style.boxShadow = theme.form.focus.boxShadow;
          }
        }}
        onBlur={(e) => {
          e.currentTarget.style.boxShadow = theme.shadows.sm;
        }}
      >
        {children}
      </button>
    </FormLayout>
  );
};

export default Button;